function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
var _hoisted_1 = {
  "class": "wrap"
};
var _hoisted_2 = {
  key: 0,
  "class": "hero"
};
var _hoisted_3 = {
  "class": "grid"
};
var _hoisted_4 = {
  "class": "card",
  "aria-labelledby": "inputs-h"
};
var _hoisted_5 = {
  "class": "row"
};
var _hoisted_6 = {
  "class": "field"
};
var _hoisted_7 = {
  "class": "inputwrap"
};
var _hoisted_8 = {
  "class": "pre"
};
var _hoisted_9 = ["value", "aria-invalid"];
var _hoisted_10 = {
  "class": "field"
};
var _hoisted_11 = {
  "class": "inputwrap"
};
var _hoisted_12 = {
  "class": "pre"
};
var _hoisted_13 = ["value", "aria-invalid"];
var _hoisted_14 = {
  "class": "row"
};
var _hoisted_15 = {
  "class": "field"
};
var _hoisted_16 = ["value", "aria-invalid"];
var _hoisted_17 = {
  "class": "field"
};
var _hoisted_18 = ["value"];
var _hoisted_19 = {
  "class": "row"
};
var _hoisted_20 = {
  "class": "field"
};
var _hoisted_21 = {
  "class": "inputwrap"
};
var _hoisted_22 = {
  "class": "pre"
};
var _hoisted_23 = ["value", "aria-invalid"];
var _hoisted_24 = {
  "class": "field"
};
var _hoisted_25 = {
  "class": "inputwrap"
};
var _hoisted_26 = {
  "class": "pre"
};
var _hoisted_27 = ["value", "aria-invalid"];
var _hoisted_28 = {
  "class": "pills",
  role: "group",
  "aria-label": "Marketplace preset"
};
var _hoisted_29 = ["aria-pressed", "onClick"];
var _hoisted_30 = ["innerHTML"];
var _hoisted_31 = {
  key: 1,
  "class": "row"
};
var _hoisted_32 = {
  "class": "field"
};
var _hoisted_33 = {
  "for": "mpPct"
};
var _hoisted_34 = {
  "class": "inputwrap"
};
var _hoisted_35 = ["value", "aria-invalid"];
var _hoisted_36 = {
  "class": "field"
};
var _hoisted_37 = {
  "class": "inputwrap"
};
var _hoisted_38 = {
  "class": "pre"
};
var _hoisted_39 = ["value", "aria-invalid"];
var _hoisted_40 = {
  "class": "row"
};
var _hoisted_41 = {
  "class": "field"
};
var _hoisted_42 = {
  "class": "inputwrap"
};
var _hoisted_43 = ["value", "aria-invalid"];
var _hoisted_44 = {
  "class": "field"
};
var _hoisted_45 = {
  "class": "inputwrap"
};
var _hoisted_46 = {
  "class": "pre"
};
var _hoisted_47 = ["value", "aria-invalid"];
var _hoisted_48 = {
  "class": "adv"
};
var _hoisted_49 = {
  "class": "adv-body"
};
var _hoisted_50 = {
  "class": "field"
};
var _hoisted_51 = {
  "class": "adv-seg-wrap"
};
var _hoisted_52 = {
  "class": "seg",
  role: "group",
  "aria-label": "Ad spend mode"
};
var _hoisted_53 = ["aria-pressed"];
var _hoisted_54 = ["aria-pressed"];
var _hoisted_55 = {
  key: 0,
  "class": "inputwrap"
};
var _hoisted_56 = ["value", "aria-invalid"];
var _hoisted_57 = {
  key: 1,
  "class": "inputwrap"
};
var _hoisted_58 = {
  "class": "pre"
};
var _hoisted_59 = ["value", "aria-invalid"];
var _hoisted_60 = {
  "class": "row"
};
var _hoisted_61 = {
  "class": "field"
};
var _hoisted_62 = {
  "class": "inputwrap"
};
var _hoisted_63 = {
  "class": "pre"
};
var _hoisted_64 = ["value", "aria-invalid"];
var _hoisted_65 = {
  "class": "field"
};
var _hoisted_66 = {
  "class": "inputwrap"
};
var _hoisted_67 = {
  "class": "pre"
};
var _hoisted_68 = ["value", "aria-invalid"];
var _hoisted_69 = {
  "class": "field"
};
var _hoisted_70 = {
  "class": "inputwrap"
};
var _hoisted_71 = ["value", "aria-invalid"];
var _hoisted_72 = {
  "class": "adv-checkbox"
};
var _hoisted_73 = {
  "class": "result"
};
var _hoisted_74 = {
  "class": "result-card",
  "aria-labelledby": "result-h"
};
var _hoisted_75 = {
  "class": "primary"
};
var _hoisted_76 = {
  "class": "totline"
};
var _hoisted_77 = {
  "class": "tiles"
};
var _hoisted_78 = {
  "class": "tile"
};
var _hoisted_79 = {
  "class": "t-val"
};
var _hoisted_80 = {
  "class": "tile"
};
var _hoisted_81 = {
  "class": "t-val"
};
var _hoisted_82 = {
  "class": "tile"
};
var _hoisted_83 = {
  "class": "t-val"
};
var _hoisted_84 = {
  "class": "tile"
};
var _hoisted_85 = {
  "class": "t-val"
};
var _hoisted_86 = {
  "class": "tile"
};
var _hoisted_87 = {
  "class": "t-val"
};
var _hoisted_88 = {
  "class": "tile"
};
var _hoisted_89 = {
  "class": "t-val"
};
var _hoisted_90 = {
  "class": "warns",
  "aria-live": "polite"
};
var _hoisted_91 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
};
var _hoisted_92 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
};
var _hoisted_93 = {
  key: 2,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
};
var _hoisted_94 = {
  "class": "breakdown"
};
var _hoisted_95 = {
  "class": "bar",
  role: "img",
  "aria-label": "Cost and profit breakdown bar"
};
var _hoisted_96 = ["title"];
var _hoisted_97 = ["title"];
var _hoisted_98 = {
  "class": "legend"
};
var _hoisted_99 = {
  "class": "name"
};
var _hoisted_100 = {
  "class": "val"
};
var _hoisted_101 = {
  "class": "li sum"
};
var _hoisted_102 = {
  "class": "val"
};
var _hoisted_103 = {
  "class": "val"
};
var _hoisted_104 = {
  "class": "sub-card"
};
var _hoisted_105 = {
  "class": "rev-grid"
};
var _hoisted_106 = {
  "class": "inputwrap rev-input"
};
var _hoisted_107 = ["value"];
var _hoisted_108 = {
  "class": "rev-grid"
};
var _hoisted_109 = {
  "class": "inputwrap rev-input"
};
var _hoisted_110 = {
  "class": "pre"
};
var _hoisted_111 = ["value"];
var _hoisted_112 = {
  "class": "rev-grid rev-grid-last"
};
var _hoisted_113 = {
  "class": "rev-note"
};
var _hoisted_114 = {
  "class": "sub-card"
};
var _hoisted_115 = {
  "class": "scen-table"
};
var _hoisted_116 = {
  key: 0
};
var _hoisted_117 = {
  key: 1
};
var _hoisted_118 = {
  "class": "footer-actions"
};
var _hoisted_119 = {
  key: 0,
  "class": "copied"
};
var _hoisted_120 = {
  key: 1,
  "class": "card embedcard",
  "aria-labelledby": "embed-h"
};
var _hoisted_121 = ["value"];
var _hoisted_122 = {
  "class": "embed-actions"
};
var _hoisted_123 = {
  key: 0,
  "class": "copied"
};
var _hoisted_124 = {
  key: 2,
  "class": "embed-powered"
};
var _hoisted_125 = {
  "class": "modal-card"
};
var _hoisted_126 = {
  "class": "modal-head"
};
var _hoisted_127 = {
  "class": "modal-body"
};
var _hoisted_128 = {
  "class": "preview-wrap"
};
var _hoisted_129 = ["src"];
import { computed, reactive, ref } from 'vue';
import { TOOL_EMBED_PROPS, buildEmbedSnippet, useToolEmbedSupport } from './shared/toolEmbed';
import { useTimedFlag, writeToClipboard } from './shared/toolClipboard';
export default {
  __name: 'ecommerceProfitCalculator',
  props: TOOL_EMBED_PROPS,
  setup: function setup(__props) {
    var PRESETS = {
      custom: {
        mpPct: 0,
        mpFixed: 0,
        mpMin: 0,
        payPct: 0,
        payFixed: 0,
        listing: 0,
        feeShip: true,
        note: null
      },
      amazon: {
        mpPct: 15,
        mpFixed: 0,
        mpMin: 0.30,
        payPct: 0,
        payFixed: 0,
        listing: 0,
        feeShip: true,
        note: '<b>Amazon:</b> 15% referral fee (most categories; range 8%-45%) with a $0.30 minimum per unit. FBA fulfilment, storage and the $39.99/mo Professional plan are not included - add fulfilment under Other costs. Source: Amazon Seller Central.'
      },
      ebay: {
        mpPct: 13.6,
        mpFixed: 0.40,
        mpMin: 0,
        payPct: 0,
        payFixed: 0,
        listing: 0,
        feeShip: true,
        note: '<b>eBay:</b> 13.6% final value fee + $0.40 per order (payment processing is bundled in). The per-order fee is $0.30 for orders $10 or under, and the % runs 2.5%-15% by category. Source: eBay Seller Center.'
      },
      etsy: {
        mpPct: 6.5,
        mpFixed: 0,
        mpMin: 0,
        payPct: 3,
        payFixed: 0.25,
        listing: 0.20,
        feeShip: true,
        note: '<b>Etsy (US):</b> 6.5% transaction + 3% + $0.25 payment processing + $0.20 listing fee per sale. Offsite Ads (12-15%) are not on by default - add them under Advertising if they apply. Source: etsy.com/legal/fees.'
      },
      shopify: {
        mpPct: 0,
        mpFixed: 0,
        mpMin: 0,
        payPct: 2.9,
        payFixed: 0.30,
        listing: 0,
        feeShip: true,
        note: '<b>Shopify (Basic + Shopify Payments):</b> 2.9% + $0.30 online (Advanced 2.5% + $0.30). Your own store, so no marketplace commission. Monthly subscription and apps are not included. Source: Shopify Pricing.'
      }
    };
    var MP_LABELS = {
      custom: 'Marketplace / selling fee',
      amazon: 'Referral fee',
      ebay: 'Final value fee',
      etsy: 'Transaction fee',
      shopify: 'Marketplace fee'
    };
    var CUR = {
      USD: {
        sym: '$',
        loc: 'en-US'
      },
      GBP: {
        sym: "\xA3",
        loc: 'en-GB'
      },
      EUR: {
        sym: "\u20AC",
        loc: 'en-IE'
      },
      AUD: {
        sym: 'A$',
        loc: 'en-AU'
      },
      NZD: {
        sym: 'NZ$',
        loc: 'en-NZ'
      },
      CAD: {
        sym: 'C$',
        loc: 'en-CA'
      }
    };
    var BREAKDOWN = [{
      key: 'marketplaceFee',
      name: 'Marketplace fee',
      color: '#0072d6'
    }, {
      key: 'paymentFee',
      name: 'Payment processing',
      color: '#4d9ee6'
    }, {
      key: 'adCost',
      name: 'Advertising',
      color: '#ff3969'
    }, {
      key: 'listingFee',
      name: 'Listing fee',
      color: '#ffa127'
    }, {
      key: 'returnsReserve',
      name: 'Returns reserve',
      color: '#9aa0b4'
    }, {
      key: 'cogs',
      name: 'Product cost',
      color: '#222a44'
    }, {
      key: 'shipCost',
      name: 'Shipping you pay',
      color: '#5b6480'
    }, {
      key: 'otherCost',
      name: 'Other costs',
      color: '#aeb4c6'
    }];
    var PRESET_OPTIONS = [['amazon', 'Amazon'], ['ebay', 'eBay'], ['etsy', 'Etsy'], ['shopify', 'Shopify'], ['custom', 'Custom / Other']];
    var SCENARIO_ROWS = [['Net / unit', 'net', 'money'], ['Margin', 'margin', 'pct'], ['ROI', 'roi', 'pct'], ['Eff. fee', 'fee', 'pct'], ['Breakeven', 'breakeven', 'money']];
    var DEFAULT_INPUTS = {
      price: '29.99',
      cogs: '11.00',
      qty: '1',
      shipCost: '4.50',
      shipCharged: '0',
      mpPct: '0',
      mpFixed: '0',
      payPct: '0',
      payFixed: '0',
      adPct: '0',
      adFixed: '0',
      otherCost: '0',
      listing: '0',
      returnsPct: '0',
      tMargin: '30',
      tProfit: '10'
    };
    var ZERO_INPUTS = Object.fromEntries(Object.keys(DEFAULT_INPUTS).map(function (key) {
      return [key, '0'];
    }));
    ZERO_INPUTS.qty = '1';
    var props = __props;
    var inputs = reactive(_objectSpread({}, DEFAULT_INPUTS));
    var preset = ref('custom');
    var adMode = ref('percent');
    var feeShip = ref(true);
    var currency = ref('USD');
    var scenA = ref(null);
    var scenB = ref(null);
    var _useTimedFlag = useTimedFlag(1800),
      copied = _useTimedFlag.flag,
      triggerCopied = _useTimedFlag.trigger,
      resetCopied = _useTimedFlag.reset;
    var _useTimedFlag2 = useTimedFlag(1800),
      embedCopied = _useTimedFlag2.flag,
      triggerEmbedCopied = _useTimedFlag2.trigger,
      resetEmbedCopied = _useTimedFlag2.reset;
    var _useToolEmbedSupport = useToolEmbedSupport({
        props: props
      }),
      rootRef = _useToolEmbedSupport.rootRef,
      previewFrameRef = _useToolEmbedSupport.previewFrameRef,
      showPreview = _useToolEmbedSupport.showPreview,
      isEmbed = _useToolEmbedSupport.isEmbed,
      pageUrl = _useToolEmbedSupport.pageUrl,
      previewSrc = _useToolEmbedSupport.previewSrc,
      showEmbedCard = _useToolEmbedSupport.showEmbedCard,
      closePreview = _useToolEmbedSupport.closePreview;
    function toNumber(value) {
      var parsed = Number.parseFloat(value);
      return Number.isNaN(parsed) ? 0 : parsed;
    }
    function isInvalid(value) {
      return value !== '' && value != null && (Number.isNaN(Number.parseFloat(value)) || Number.parseFloat(value) < 0);
    }
    function fmt(value, currencyCode) {
      var config = CUR[currencyCode] || CUR.USD;
      var sign = value < 0 ? '-' : '';
      try {
        return sign + new Intl.NumberFormat(config.loc, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(Math.abs(value));
      } catch (error) {
        return "".concat(sign).concat(config.sym).concat(Math.abs(value).toFixed(2));
      }
    }
    function pct(value) {
      if (!Number.isFinite(value)) {
        return "\u221E";
      }
      var rounded = (Math.round(value * 10) / 10).toFixed(1).replace(/\.0$/, '');
      return "".concat(rounded, "%");
    }
    function compute(state, presetKey, adModeKey, feeShipping) {
      var price = toNumber(state.price);
      var cogs = toNumber(state.cogs);
      var qty = Math.max(1, Math.floor(toNumber(state.qty)) || 1);
      var shipCost = toNumber(state.shipCost);
      var shipCharged = toNumber(state.shipCharged);
      var mpPct = toNumber(state.mpPct);
      var mpFixed = toNumber(state.mpFixed);
      var payPct = toNumber(state.payPct);
      var payFixed = toNumber(state.payFixed);
      var otherCost = toNumber(state.otherCost);
      var listing = toNumber(state.listing);
      var returnsPct = toNumber(state.returnsPct);
      var mpMin = (PRESETS[presetKey] || {}).mpMin || 0;
      var adPct = toNumber(state.adPct);
      var adFixed = toNumber(state.adFixed);
      var revenue = price + shipCharged;
      var feeBase = feeShipping ? revenue : price;
      var marketplaceFee = revenue > 0 ? Math.max(mpPct / 100 * feeBase, mpMin) + mpFixed : 0;
      var paymentFee = revenue > 0 ? payPct / 100 * revenue + payFixed : 0;
      var adCost = adModeKey === 'percent' ? adPct / 100 * revenue : adFixed;
      var returnsReserve = returnsPct / 100 * revenue;
      var listingFee = listing;
      var totalFees = marketplaceFee + paymentFee + adCost + listingFee + returnsReserve;
      var investment = cogs + shipCost + otherCost;
      var totalCosts = investment;
      var netProfit = revenue - totalFees - totalCosts;
      var margin = revenue > 0 ? netProfit / revenue * 100 : 0;
      var roi = investment > 0 ? netProfit / investment * 100 : netProfit > 0 ? Infinity : 0;
      var markup = cogs > 0 ? (price - cogs) / cogs * 100 : 0;
      var effFee = revenue > 0 ? totalFees / revenue * 100 : 0;
      var a = 1 - mpPct / 100 - payPct / 100 - (adModeKey === 'percent' ? adPct / 100 : 0) - returnsPct / 100;
      var shippingRevenue = shipCharged;
      var b = shippingRevenue - (feeShipping ? mpPct / 100 * shippingRevenue : 0) - mpFixed - (payPct / 100 * shippingRevenue + payFixed) - (adModeKey === 'percent' ? adPct / 100 * shippingRevenue : adFixed) - returnsPct / 100 * shippingRevenue - listingFee - investment;
      var breakeven = a > 0 ? -b / a : null;
      return {
        price: price,
        cogs: cogs,
        qty: qty,
        shipCost: shipCost,
        shipCharged: shipCharged,
        revenue: revenue,
        marketplaceFee: marketplaceFee,
        paymentFee: paymentFee,
        adCost: adCost,
        listingFee: listingFee,
        returnsReserve: returnsReserve,
        otherCost: otherCost,
        totalFees: totalFees,
        totalCosts: totalCosts,
        netProfit: netProfit,
        margin: margin,
        roi: roi,
        markup: markup,
        effFee: effFee,
        a: a,
        b: b,
        breakeven: breakeven,
        investment: investment
      };
    }
    var currentPreset = computed(function () {
      return PRESETS[preset.value] || PRESETS.custom;
    });
    var currentPresetNote = computed(function () {
      return currentPreset.value.note;
    });
    var symbol = computed(function () {
      return (CUR[currency.value] || CUR.USD).sym;
    });
    var result = computed(function () {
      return compute(inputs, preset.value, adMode.value, feeShip.value);
    });
    var mpLabel = computed(function () {
      return MP_LABELS[preset.value] || 'Marketplace fee';
    });
    var segments = computed(function () {
      return BREAKDOWN.filter(function (segment) {
        return (result.value[segment.key] || 0) > 0.0001;
      });
    });
    var breakdownBase = computed(function () {
      return Math.max(result.value.revenue, result.value.totalFees + result.value.totalCosts, 0.01);
    });
    var targetMarginDecimal = computed(function () {
      return toNumber(inputs.tMargin) / 100;
    });
    var targetProfitValue = computed(function () {
      return toNumber(inputs.tProfit);
    });
    var reachableMargin = computed(function () {
      return result.value.a - targetMarginDecimal.value > 0;
    });
    var priceForMargin = computed(function () {
      if (!reachableMargin.value) {
        return null;
      }
      return (targetMarginDecimal.value * result.value.shipCharged - result.value.b) / (result.value.a - targetMarginDecimal.value);
    });
    var priceForProfit = computed(function () {
      return result.value.a > 0 ? (targetProfitValue.value - result.value.b) / result.value.a : null;
    });
    var maxCogs = computed(function () {
      return result.value.revenue > 0 ? result.value.revenue * (1 - targetMarginDecimal.value) - result.value.totalFees - result.value.shipCost - result.value.otherCost : null;
    });
    var embedSnippet = computed(function () {
      return buildEmbedSnippet({
        pageUrl: pageUrl.value,
        iframeTitle: 'Ecommerce Profit Calculator by SaleHoo',
        initialHeight: 1500
      });
    });
    var warnings = computed(function () {
      var items = [];
      if (result.value.price <= 0) {
        items.push({
          type: 'info',
          message: 'Enter a selling price to see your profit.'
        });
      } else if (result.value.netProfit < 0) {
        items.push({
          type: 'err',
          message: "You're selling at a loss of ".concat(fmt(Math.abs(result.value.netProfit), currency.value), " per unit. Raise the price to your breakeven of ").concat(result.value.breakeven > 0 ? fmt(result.value.breakeven, currency.value) : "\u2014", ", cut costs, or trim fees.")
        });
      } else if (result.value.margin < 10 && result.value.margin >= 0) {
        items.push({
          type: 'warn',
          message: "Thin margin (".concat(pct(result.value.margin), "). Little room for ad spend, returns or a price drop. Many sellers aim for 20%+.")
        });
      }
      if (result.value.a <= 0) {
        items.push({
          type: 'err',
          message: 'Your percentage fees add up to 100% or more of revenue, so no price can turn a profit. Reduce the fee and ad percentages.'
        });
      }
      if (result.value.cogs <= 0 && result.value.price > 0) {
        items.push({
          type: 'info',
          message: "Product cost is zero, so ROI and markup can't be calculated meaningfully."
        });
      }
      if (result.value.shipCharged > 0 && result.value.shipCharged < result.value.shipCost) {
        items.push({
          type: 'warn',
          message: "You charge buyers less for shipping (".concat(fmt(result.value.shipCharged, currency.value), ") than it costs you (").concat(fmt(result.value.shipCost, currency.value), "). The gap eats your margin.")
        });
      }
      return items;
    });
    function formatScenarioCell(snapshot, key, kind) {
      if (!snapshot) {
        return "\u2014";
      }
      if (key === 'breakeven') {
        return snapshot[key] > 0 ? fmt(snapshot[key], currency.value) : "\u2014";
      }
      return kind === 'pct' ? pct(snapshot[key]) : fmt(snapshot[key], currency.value);
    }
    function formatScenarioDelta(key, kind) {
      if (!scenA.value || !scenB.value) {
        return {
          text: "\u2014",
          color: ''
        };
      }
      var deltaValue = scenB.value[key] - scenA.value[key];
      if (kind === 'pct') {
        var deltaPct = pct(deltaValue).replace('%', '');
        return {
          text: "".concat(deltaValue >= 0 ? '+' : '').concat(deltaPct, "%"),
          color: deltaValue >= 0 ? 'var(--green-d)' : 'var(--danger)'
        };
      }
      return {
        text: "".concat(deltaValue >= 0 ? '+' : '').concat(fmt(deltaValue, currency.value)),
        color: deltaValue >= 0 ? 'var(--green-d)' : 'var(--danger)'
      };
    }
    var scenarioTableRows = computed(function () {
      return SCENARIO_ROWS.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
          label = _ref2[0],
          key = _ref2[1],
          kind = _ref2[2];
        var delta = formatScenarioDelta(key, kind);
        return {
          label: label,
          key: key,
          valueA: formatScenarioCell(scenA.value, key, kind),
          valueB: formatScenarioCell(scenB.value, key, kind),
          deltaText: delta.text,
          deltaColor: delta.color
        };
      });
    });
    function updateField(field, value) {
      inputs[field] = value;
    }
    function applyPreset(nextPreset) {
      var config = PRESETS[nextPreset];
      preset.value = nextPreset;
      feeShip.value = config.feeShip;
      Object.assign(inputs, {
        mpPct: String(config.mpPct),
        mpFixed: String(config.mpFixed),
        payPct: String(config.payPct),
        payFixed: String(config.payFixed),
        listing: String(config.listing)
      });
    }
    function reset() {
      Object.assign(inputs, _objectSpread(_objectSpread({}, ZERO_INPUTS), {}, {
        tMargin: '0',
        tProfit: '0'
      }));
      preset.value = 'custom';
      adMode.value = 'percent';
      feeShip.value = true;
      currency.value = 'USD';
      scenA.value = null;
      scenB.value = null;
      resetCopied();
      resetEmbedCopied();
      showPreview.value = false;
    }
    function snapshotScenario() {
      return {
        net: result.value.netProfit,
        margin: result.value.margin,
        roi: result.value.roi,
        fee: result.value.effFee,
        breakeven: result.value.breakeven,
        price: result.value.price
      };
    }
    function pinScenarioA() {
      scenA.value = snapshotScenario();
    }
    function pinScenarioB() {
      scenB.value = snapshotScenario();
    }
    function copySummary() {
      return _copySummary.apply(this, arguments);
    }
    function _copySummary() {
      _copySummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var lines, copiedText;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              lines = ["Ecommerce Profit Calculator - summary (".concat(currency.value, ")"), "Platform: ".concat(preset.value === 'custom' ? 'Custom' : preset.value), "Selling price: ".concat(fmt(result.value.price, currency.value), "  |  Product cost: ").concat(fmt(result.value.cogs, currency.value), "  |  Qty: ").concat(result.value.qty), "Revenue/unit: ".concat(fmt(result.value.revenue, currency.value)), "Total fees/unit: ".concat(fmt(result.value.totalFees, currency.value), " (effective ").concat(pct(result.value.effFee), ")"), "Total costs/unit: ".concat(fmt(result.value.totalCosts, currency.value)), "Net profit/unit: ".concat(fmt(result.value.netProfit, currency.value), "  |  Order total: ").concat(fmt(result.value.netProfit * result.value.qty, currency.value)), "Margin: ".concat(pct(result.value.margin), "  |  ROI: ").concat(Number.isFinite(result.value.roi) ? pct(result.value.roi) : 'inf', "  |  Breakeven: ").concat(result.value.breakeven > 0 ? fmt(result.value.breakeven, currency.value) : 'n/a'), '', 'Estimate only - verify current fees with the platform.'].join('\n');
              _context.next = 3;
              return writeToClipboard(lines);
            case 3:
              copiedText = _context.sent;
              if (copiedText) {
                _context.next = 7;
                break;
              }
              resetCopied();
              return _context.abrupt("return");
            case 7:
              triggerCopied();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _copySummary.apply(this, arguments);
    }
    function copyEmbed() {
      return _copyEmbed.apply(this, arguments);
    }
    function _copyEmbed() {
      _copyEmbed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var copiedText;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return writeToClipboard(embedSnippet.value);
            case 2:
              copiedText = _context2.sent;
              if (copiedText) {
                _context2.next = 6;
                break;
              }
              resetEmbedCopied();
              return _context2.abrupt("return");
            case 6:
              triggerEmbedCopied();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _copyEmbed.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "rootRef",
        ref: rootRef,
        "class": _normalizeClass(['epc', {
          embed: _unref(isEmbed)
        }])
      }, [_createElementVNode("div", _hoisted_1, [_unref(isEmbed) ? (_openBlock(), _createElementBlock("header", _hoisted_2, _cache[24] || (_cache[24] = [_createElementVNode("h1", null, "Ecommerce Profit Calculator", -1)]))) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("section", _hoisted_4, [_cache[52] || (_cache[52] = _createStaticVNode("<div class=\"card-h\" data-v-7dfbd0ca><h2 id=\"inputs-h\" data-v-7dfbd0ca> Your numbers </h2></div><p class=\"card-sub\" data-v-7dfbd0ca> Start with the basics, then pick a platform below to pre-fill its fees. </p><div class=\"section-label\" data-v-7dfbd0ca> The essentials <span class=\"hr\" data-v-7dfbd0ca></span></div>", 3)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[25] || (_cache[25] = _createElementVNode("label", {
        "for": "price"
      }, [_createTextVNode(" Selling price "), _createElementVNode("span", {
        "class": "q",
        title: "The price the buyer pays for the item, before sales tax. Per unit."
      }, "(per unit)")], -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "price",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.price,
        "aria-invalid": isInvalid(inputs.price),
        "aria-describedby": "price-h",
        onInput: _cache[0] || (_cache[0] = function ($event) {
          return updateField('price', $event.target.value);
        })
      }, null, 40, _hoisted_9)]), _cache[26] || (_cache[26] = _createElementVNode("p", {
        id: "price-h",
        "class": "hint"
      }, " Excludes sales tax (treated as pass-through). ", -1))]), _createElementVNode("div", _hoisted_10, [_cache[27] || (_cache[27] = _createElementVNode("label", {
        "for": "cogs"
      }, [_createTextVNode(" Product cost "), _createElementVNode("span", {
        "class": "q",
        title: "Also called COGS. What the item costs you to buy or make, landed. Per unit."
      }, "(per unit)")], -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "cogs",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.cogs,
        "aria-invalid": isInvalid(inputs.cogs),
        onInput: _cache[1] || (_cache[1] = function ($event) {
          return updateField('cogs', $event.target.value);
        })
      }, null, 40, _hoisted_13)]), _cache[28] || (_cache[28] = _createElementVNode("p", {
        "class": "hint"
      }, " Your landed cost: purchase or manufacturing. ", -1))])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[29] || (_cache[29] = _createElementVNode("label", {
        "for": "qty"
      }, "Units sold", -1)), _createElementVNode("input", {
        id: "qty",
        type: "number",
        min: "1",
        step: "1",
        inputmode: "numeric",
        value: inputs.qty,
        "aria-invalid": isInvalid(inputs.qty),
        onInput: _cache[2] || (_cache[2] = function ($event) {
          return updateField('qty', $event.target.value);
        })
      }, null, 40, _hoisted_16), _cache[30] || (_cache[30] = _createElementVNode("p", {
        "class": "hint"
      }, " Scales the order totals. Margins stay per-unit. ", -1))]), _createElementVNode("div", _hoisted_17, [_cache[31] || (_cache[31] = _createElementVNode("label", {
        "for": "currency"
      }, "Currency", -1)), _withDirectives(_createElementVNode("select", {
        id: "currency",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return currency.value = $event;
        }),
        "aria-describedby": "cur-h"
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(CUR, function (config, code) {
        return _createElementVNode("option", {
          key: code,
          value: code
        }, _toDisplayString(code) + " (" + _toDisplayString(config.sym) + ") ", 9, _hoisted_18);
      }), 64))], 512), [[_vModelSelect, currency.value]]), _cache[32] || (_cache[32] = _createElementVNode("p", {
        id: "cur-h",
        "class": "hint"
      }, " Formatting only. ", -1))])]), _cache[53] || (_cache[53] = _createElementVNode("div", {
        "class": "section-label"
      }, [_createTextVNode(" Shipping "), _createElementVNode("span", {
        "class": "hr"
      })], -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[33] || (_cache[33] = _createElementVNode("label", {
        "for": "shipCost"
      }, [_createTextVNode(" Shipping you pay "), _createElementVNode("span", {
        "class": "q",
        title: "Your actual label / carrier cost per order."
      }, "(to the carrier)")], -1)), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "shipCost",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.shipCost,
        "aria-invalid": isInvalid(inputs.shipCost),
        onInput: _cache[4] || (_cache[4] = function ($event) {
          return updateField('shipCost', $event.target.value);
        })
      }, null, 40, _hoisted_23)])]), _createElementVNode("div", _hoisted_24, [_cache[34] || (_cache[34] = _createElementVNode("label", {
        "for": "shipCharged"
      }, [_createTextVNode(" Shipping the buyer pays "), _createElementVNode("span", {
        "class": "q",
        title: "Shipping revenue: what the buyer pays you for delivery. Set to 0 for free shipping."
      }, "(to you)")], -1)), _createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "shipCharged",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.shipCharged,
        "aria-invalid": isInvalid(inputs.shipCharged),
        onInput: _cache[5] || (_cache[5] = function ($event) {
          return updateField('shipCharged', $event.target.value);
        })
      }, null, 40, _hoisted_27)]), _cache[35] || (_cache[35] = _createElementVNode("p", {
        "class": "hint"
      }, " Set to 0 if you offer free shipping (cost baked into price). ", -1))])]), _cache[54] || (_cache[54] = _createElementVNode("div", {
        "class": "section-label"
      }, [_createTextVNode(" Platform & fees "), _createElementVNode("span", {
        "class": "hr"
      })], -1)), _createElementVNode("div", _hoisted_28, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(PRESET_OPTIONS, function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          presetKey = _ref4[0],
          label = _ref4[1];
        return _createElementVNode("button", {
          key: presetKey,
          type: "button",
          "class": "pill",
          "aria-pressed": preset.value === presetKey,
          onClick: function onClick($event) {
            return applyPreset(presetKey);
          }
        }, _toDisplayString(label), 9, _hoisted_29);
      }), 64))]), currentPresetNote.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "presetnote",
        innerHTML: currentPresetNote.value
      }, null, 8, _hoisted_30)) : _createCommentVNode("", true), _cache[55] || (_cache[55] = _createElementVNode("p", {
        "class": "hint preset-hint"
      }, " Pick a platform to pre-fill its fees, then edit any field. Your edits override the preset. ", -1)), preset.value !== 'shopify' ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("label", _hoisted_33, _toDisplayString(mpLabel.value), 1), _createElementVNode("div", _hoisted_34, [_createElementVNode("input", {
        id: "mpPct",
        "class": "has-post",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.mpPct,
        "aria-invalid": isInvalid(inputs.mpPct),
        onInput: _cache[6] || (_cache[6] = function ($event) {
          return updateField('mpPct', $event.target.value);
        })
      }, null, 40, _hoisted_35), _cache[36] || (_cache[36] = _createElementVNode("span", {
        "class": "post"
      }, "%", -1))])]), _createElementVNode("div", _hoisted_36, [_cache[37] || (_cache[37] = _createElementVNode("label", {
        "for": "mpFixed"
      }, "Flat fee per order", -1)), _createElementVNode("div", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "mpFixed",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.mpFixed,
        "aria-invalid": isInvalid(inputs.mpFixed),
        onInput: _cache[7] || (_cache[7] = function ($event) {
          return updateField('mpFixed', $event.target.value);
        })
      }, null, 40, _hoisted_39)])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_cache[39] || (_cache[39] = _createElementVNode("label", {
        "for": "payPct"
      }, "Payment processing fee", -1)), _createElementVNode("div", _hoisted_42, [_createElementVNode("input", {
        id: "payPct",
        "class": "has-post",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.payPct,
        "aria-invalid": isInvalid(inputs.payPct),
        onInput: _cache[8] || (_cache[8] = function ($event) {
          return updateField('payPct', $event.target.value);
        })
      }, null, 40, _hoisted_43), _cache[38] || (_cache[38] = _createElementVNode("span", {
        "class": "post"
      }, "%", -1))])]), _createElementVNode("div", _hoisted_44, [_cache[40] || (_cache[40] = _createElementVNode("label", {
        "for": "payFixed"
      }, "Flat fee per transaction", -1)), _createElementVNode("div", _hoisted_45, [_createElementVNode("span", _hoisted_46, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "payFixed",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.payFixed,
        "aria-invalid": isInvalid(inputs.payFixed),
        onInput: _cache[9] || (_cache[9] = function ($event) {
          return updateField('payFixed', $event.target.value);
        })
      }, null, 40, _hoisted_47)])])]), _createElementVNode("details", _hoisted_48, [_cache[50] || (_cache[50] = _createElementVNode("summary", null, [_createElementVNode("span", {
        "class": "caret"
      }, [_createElementVNode("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "3"
      }, [_createElementVNode("path", {
        d: "M9 6l6 6-6 6"
      })])]), _createTextVNode(" Advanced settings ")], -1)), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_cache[42] || (_cache[42] = _createElementVNode("label", null, "Advertising / promotion", -1)), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("button", {
        type: "button",
        "aria-pressed": adMode.value === 'percent',
        onClick: _cache[10] || (_cache[10] = function ($event) {
          return adMode.value = 'percent';
        })
      }, " % of revenue ", 8, _hoisted_53), _createElementVNode("button", {
        type: "button",
        "aria-pressed": adMode.value === 'fixed',
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return adMode.value = 'fixed';
        })
      }, " Fixed $/unit ", 8, _hoisted_54)])]), adMode.value === 'percent' ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("input", {
        id: "adPct",
        "class": "has-post",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.adPct,
        "aria-invalid": isInvalid(inputs.adPct),
        onInput: _cache[12] || (_cache[12] = function ($event) {
          return updateField('adPct', $event.target.value);
        })
      }, null, 40, _hoisted_56), _cache[41] || (_cache[41] = _createElementVNode("span", {
        "class": "post"
      }, "%", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_57, [_createElementVNode("span", _hoisted_58, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "adFixed",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.adFixed,
        "aria-invalid": isInvalid(inputs.adFixed),
        onInput: _cache[13] || (_cache[13] = function ($event) {
          return updateField('adFixed', $event.target.value);
        })
      }, null, 40, _hoisted_59)])), _cache[43] || (_cache[43] = _createElementVNode("p", {
        "class": "hint"
      }, " Ad cost per sale (e.g. Etsy Offsite Ads, Amazon PPC, promoted listings, Meta). ", -1))]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_cache[44] || (_cache[44] = _createElementVNode("label", {
        "for": "otherCost"
      }, [_createTextVNode(" Other costs / unit "), _createElementVNode("span", {
        "class": "q",
        title: "Packaging, inserts, inbound freight, handling, per-unit overhead."
      }, "(packaging etc.)")], -1)), _createElementVNode("div", _hoisted_62, [_createElementVNode("span", _hoisted_63, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "otherCost",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.otherCost,
        "aria-invalid": isInvalid(inputs.otherCost),
        onInput: _cache[14] || (_cache[14] = function ($event) {
          return updateField('otherCost', $event.target.value);
        })
      }, null, 40, _hoisted_64)])]), _createElementVNode("div", _hoisted_65, [_cache[45] || (_cache[45] = _createElementVNode("label", {
        "for": "listing"
      }, "Listing / insertion fee", -1)), _createElementVNode("div", _hoisted_66, [_createElementVNode("span", _hoisted_67, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "listing",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.listing,
        "aria-invalid": isInvalid(inputs.listing),
        onInput: _cache[15] || (_cache[15] = function ($event) {
          return updateField('listing', $event.target.value);
        })
      }, null, 40, _hoisted_68)])])]), _createElementVNode("div", _hoisted_69, [_cache[47] || (_cache[47] = _createElementVNode("label", {
        "for": "returnsPct"
      }, [_createTextVNode(" Returns allowance "), _createElementVNode("span", {
        "class": "q",
        title: "Money set aside per sale to cover refunds and return shipping, as a % of revenue. A simple estimate, not a precise per-return model."
      }, "(% of sales)")], -1)), _createElementVNode("div", _hoisted_70, [_createElementVNode("input", {
        id: "returnsPct",
        "class": "has-post",
        type: "number",
        min: "0",
        max: "100",
        step: "0.1",
        inputmode: "decimal",
        value: inputs.returnsPct,
        "aria-invalid": isInvalid(inputs.returnsPct),
        onInput: _cache[16] || (_cache[16] = function ($event) {
          return updateField('returnsPct', $event.target.value);
        })
      }, null, 40, _hoisted_71), _cache[46] || (_cache[46] = _createElementVNode("span", {
        "class": "post"
      }, "%", -1))]), _cache[48] || (_cache[48] = _createElementVNode("p", {
        "class": "hint"
      }, " Blended allowance for refunds. Leave 0 to ignore. ", -1))]), _createElementVNode("div", _hoisted_72, [_withDirectives(_createElementVNode("input", {
        id: "feeShip",
        "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
          return feeShip.value = $event;
        }),
        type: "checkbox"
      }, null, 512), [[_vModelCheckbox, feeShip.value]]), _cache[49] || (_cache[49] = _createElementVNode("label", {
        "for": "feeShip"
      }, [_createTextVNode(" Marketplace fee applies to buyer-paid shipping "), _createElementVNode("span", null, "True for eBay, Amazon and Etsy: they charge the % on item price plus shipping. Untick for platforms that only fee the item price.")], -1))])])]), _createElementVNode("button", {
        type: "button",
        "class": "btn btn-ghost btn-block",
        onClick: reset
      }, _cache[51] || (_cache[51] = [_createElementVNode("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.2"
      }, [_createElementVNode("path", {
        d: "M3 12a9 9 0 1 0 3-6.7L3 8"
      }), _createElementVNode("path", {
        d: "M3 3v5h5"
      })], -1), _createTextVNode(" Reset to defaults ")]))]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_cache[83] || (_cache[83] = _createElementVNode("h2", {
        id: "result-h",
        "class": "visually-hidden"
      }, " Results ", -1)), _createElementVNode("div", _hoisted_75, [_cache[58] || (_cache[58] = _createElementVNode("div", {
        "class": "lbl"
      }, " Net profit per unit ", -1)), _createElementVNode("div", {
        "class": _normalizeClass(["bignum", result.value.netProfit >= 0 ? 'pos' : 'neg']),
        "aria-live": "polite"
      }, _toDisplayString(fmt(result.value.netProfit, currency.value)), 3), _cache[59] || (_cache[59] = _createElementVNode("div", {
        "class": "unit"
      }, " after all fees, shipping and costs ", -1)), _createElementVNode("div", _hoisted_76, [_cache[56] || (_cache[56] = _createTextVNode(" Total for ")), _createElementVNode("b", null, _toDisplayString(result.value.qty), 1), _createTextVNode(" unit" + _toDisplayString(result.value.qty === 1 ? '' : 's') + ": ", 1), _createElementVNode("b", null, _toDisplayString(fmt(result.value.netProfit * result.value.qty, currency.value)), 1)]), _createElementVNode("span", {
        "class": _normalizeClass(["mbadge", result.value.margin >= 0 ? 'pos' : 'neg'])
      }, [_cache[57] || (_cache[57] = _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.5"
      }, [_createElementVNode("path", {
        d: "M7 17L17 7M17 7H8M17 7v9"
      })], -1)), _createElementVNode("span", null, _toDisplayString(pct(result.value.margin)) + " margin", 1)], 2)]), _createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_cache[60] || (_cache[60] = _createElementVNode("div", {
        "class": "t-lbl"
      }, "Profit margin", -1)), _createElementVNode("div", _hoisted_79, _toDisplayString(pct(result.value.margin)), 1)]), _createElementVNode("div", _hoisted_80, [_cache[61] || (_cache[61] = _createElementVNode("div", {
        "class": "t-lbl"
      }, "Return on cost (ROI)", -1)), _createElementVNode("div", _hoisted_81, _toDisplayString(Number.isFinite(result.value.roi) ? pct(result.value.roi) : "\u221E"), 1)]), _createElementVNode("div", _hoisted_82, [_cache[62] || (_cache[62] = _createElementVNode("div", {
        "class": "t-lbl"
      }, "Markup", -1)), _createElementVNode("div", _hoisted_83, _toDisplayString(pct(result.value.markup)), 1)]), _createElementVNode("div", _hoisted_84, [_cache[63] || (_cache[63] = _createElementVNode("div", {
        "class": "t-lbl"
      }, "Effective fee rate", -1)), _createElementVNode("div", _hoisted_85, _toDisplayString(pct(result.value.effFee)), 1)]), _createElementVNode("div", _hoisted_86, [_cache[64] || (_cache[64] = _createElementVNode("div", {
        "class": "t-lbl"
      }, "Breakeven price", -1)), _createElementVNode("div", _hoisted_87, _toDisplayString(result.value.breakeven != null && result.value.breakeven > 0 ? fmt(result.value.breakeven, currency.value) : "\u2014"), 1)]), _createElementVNode("div", _hoisted_88, [_cache[65] || (_cache[65] = _createElementVNode("div", {
        "class": "t-lbl"
      }, "Revenue / unit", -1)), _createElementVNode("div", _hoisted_89, _toDisplayString(fmt(result.value.revenue, currency.value)), 1)])]), _createElementVNode("div", _hoisted_90, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warnings.value, function (warning, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          "class": _normalizeClass(["warn-item", warning.type])
        }, [warning.type === 'err' ? (_openBlock(), _createElementBlock("svg", _hoisted_91, _cache[66] || (_cache[66] = [_createElementVNode("path", {
          d: "M12 9v4"
        }, null, -1), _createElementVNode("path", {
          d: "M12 17h.01"
        }, null, -1), _createElementVNode("circle", {
          cx: "12",
          cy: "12",
          r: "9"
        }, null, -1)]))) : warning.type === 'warn' ? (_openBlock(), _createElementBlock("svg", _hoisted_92, _cache[67] || (_cache[67] = [_createElementVNode("path", {
          d: "M12 9v4"
        }, null, -1), _createElementVNode("path", {
          d: "M12 17h.01"
        }, null, -1), _createElementVNode("path", {
          d: "M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"
        }, null, -1)]))) : (_openBlock(), _createElementBlock("svg", _hoisted_93, _cache[68] || (_cache[68] = [_createElementVNode("circle", {
          cx: "12",
          cy: "12",
          r: "9"
        }, null, -1), _createElementVNode("path", {
          d: "M12 11v5"
        }, null, -1), _createElementVNode("path", {
          d: "M12 8h.01"
        }, null, -1)]))), _createElementVNode("span", null, _toDisplayString(warning.message), 1)], 2);
      }), 128))]), _createElementVNode("div", _hoisted_94, [_cache[71] || (_cache[71] = _createElementVNode("div", {
        "class": "bd-h"
      }, [_createElementVNode("span", null, "Where the money goes"), _createElementVNode("span", {
        "class": "bd-h-meta"
      }, "per unit")], -1)), _createElementVNode("div", _hoisted_95, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, function (segment) {
        return _openBlock(), _createElementBlock("span", {
          key: segment.key,
          style: _normalizeStyle({
            background: segment.color,
            width: "".concat((result.value[segment.key] || 0) / breakdownBase.value * 100, "%")
          }),
          title: "".concat(segment.name, " ").concat(fmt(result.value[segment.key], currency.value))
        }, null, 12, _hoisted_96);
      }), 128)), result.value.netProfit > 0 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: _normalizeStyle({
          background: '#00c489',
          width: "".concat(result.value.netProfit / breakdownBase.value * 100, "%")
        }),
        title: "Net profit ".concat(fmt(result.value.netProfit, currency.value))
      }, null, 12, _hoisted_97)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_98, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, function (segment) {
        return _openBlock(), _createElementBlock("div", {
          key: "".concat(segment.key, "-legend"),
          "class": "li"
        }, [_createElementVNode("span", _hoisted_99, [_createElementVNode("span", {
          "class": "sw",
          style: _normalizeStyle({
            background: segment.color
          })
        }, null, 4), _createTextVNode(" " + _toDisplayString(segment.name), 1)]), _createElementVNode("span", _hoisted_100, _toDisplayString(fmt(result.value[segment.key], currency.value)), 1)]);
      }), 128)), _createElementVNode("div", _hoisted_101, [_cache[69] || (_cache[69] = _createElementVNode("span", {
        "class": "name"
      }, [_createElementVNode("span", {
        "class": "sw",
        style: {
          background: 'transparent'
        }
      }), _createTextVNode(" Total fees + costs ")], -1)), _createElementVNode("span", _hoisted_102, _toDisplayString(fmt(result.value.totalFees + result.value.totalCosts, currency.value)), 1)]), _createElementVNode("div", {
        "class": _normalizeClass(["li profit", {
          neg: result.value.netProfit < 0
        }])
      }, [_cache[70] || (_cache[70] = _createElementVNode("span", {
        "class": "name"
      }, [_createElementVNode("span", {
        "class": "sw",
        style: {
          background: '#00c489'
        }
      }), _createTextVNode(" Net profit ")], -1)), _createElementVNode("span", _hoisted_103, _toDisplayString(fmt(result.value.netProfit, currency.value)), 1)], 2)])]), _createElementVNode("div", _hoisted_104, [_cache[76] || (_cache[76] = _createElementVNode("h3", null, "Reverse: what price do I need?", -1)), _cache[77] || (_cache[77] = _createElementVNode("p", {
        "class": "card-sub"
      }, " Holds your costs, fees and buyer-paid shipping fixed, then solves for the selling price. ", -1)), _createElementVNode("div", _hoisted_105, [_createElementVNode("div", null, [_cache[73] || (_cache[73] = _createElementVNode("label", {
        "for": "tMargin",
        "class": "tight-label"
      }, "Price for target margin", -1)), _createElementVNode("div", _hoisted_106, [_createElementVNode("input", {
        id: "tMargin",
        "class": "has-post",
        type: "number",
        min: "0",
        max: "99",
        step: "1",
        inputmode: "decimal",
        value: inputs.tMargin,
        onInput: _cache[18] || (_cache[18] = function ($event) {
          return updateField('tMargin', $event.target.value);
        })
      }, null, 40, _hoisted_107), _cache[72] || (_cache[72] = _createElementVNode("span", {
        "class": "post"
      }, "%", -1))])]), _createElementVNode("div", {
        "class": _normalizeClass(["rev-out", {
          na: !reachableMargin.value
        }])
      }, _toDisplayString(reachableMargin.value ? priceForMargin.value > 0 ? fmt(priceForMargin.value, currency.value) : "\u2014" : 'Not reachable'), 3)]), _createElementVNode("div", _hoisted_108, [_createElementVNode("div", null, [_cache[74] || (_cache[74] = _createElementVNode("label", {
        "for": "tProfit",
        "class": "tight-label"
      }, "Price for target profit / unit", -1)), _createElementVNode("div", _hoisted_109, [_createElementVNode("span", _hoisted_110, _toDisplayString(symbol.value), 1), _createElementVNode("input", {
        id: "tProfit",
        "class": "has-pre",
        type: "number",
        min: "0",
        step: "0.01",
        inputmode: "decimal",
        value: inputs.tProfit,
        onInput: _cache[19] || (_cache[19] = function ($event) {
          return updateField('tProfit', $event.target.value);
        })
      }, null, 40, _hoisted_111)])]), _createElementVNode("div", {
        "class": _normalizeClass(["rev-out", {
          na: !(result.value.a > 0)
        }])
      }, _toDisplayString(result.value.a > 0 ? priceForProfit.value > 0 ? fmt(priceForProfit.value, currency.value) : "\u2014" : 'Not reachable'), 3)]), _createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_createTextVNode(" Max product cost to keep " + _toDisplayString(toNumber(inputs.tMargin) || 0) + "% margin ", 1), _cache[75] || (_cache[75] = _createElementVNode("span", null, "(at current price)", -1))]), _createElementVNode("div", {
        "class": _normalizeClass(["rev-out", {
          na: !(maxCogs.value != null && maxCogs.value > 0)
        }])
      }, _toDisplayString(maxCogs.value == null ? "\u2014" : maxCogs.value > 0 ? fmt(maxCogs.value, currency.value) : "".concat(fmt(0, currency.value), " (impossible at this price)")), 3)])]), _createElementVNode("div", _hoisted_114, [_cache[80] || (_cache[80] = _createElementVNode("h3", null, "Compare two scenarios", -1)), _cache[81] || (_cache[81] = _createElementVNode("p", {
        "class": "card-sub"
      }, " Pin your current setup, change a few inputs, then pin again to see the difference. ", -1)), _createElementVNode("div", {
        "class": "scen-actions"
      }, [_createElementVNode("button", {
        type: "button",
        "class": "btn btn-ghost",
        onClick: pinScenarioA
      }, " Pin as A "), _createElementVNode("button", {
        type: "button",
        "class": "btn btn-ghost",
        onClick: pinScenarioB
      }, " Pin as B ")]), _createElementVNode("table", _hoisted_115, [_cache[79] || (_cache[79] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "Metric"), _createElementVNode("th", null, "A"), _createElementVNode("th", null, "B"), _createElementVNode("th", null, "Delta")])], -1)), scenA.value || scenB.value ? (_openBlock(), _createElementBlock("tbody", _hoisted_116, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scenarioTableRows.value, function (row) {
        return _openBlock(), _createElementBlock("tr", {
          key: row.key
        }, [_createElementVNode("td", null, _toDisplayString(row.label), 1), _createElementVNode("td", null, _toDisplayString(row.valueA), 1), _createElementVNode("td", null, _toDisplayString(row.valueB), 1), _createElementVNode("td", {
          style: _normalizeStyle({
            color: row.deltaColor
          })
        }, _toDisplayString(row.deltaText), 5)]);
      }), 128))])) : (_openBlock(), _createElementBlock("tbody", _hoisted_117, _cache[78] || (_cache[78] = [_createElementVNode("tr", null, [_createElementVNode("td", {
        colspan: "4",
        "class": "scen-empty"
      }, " No scenarios pinned yet. ")], -1)])))])]), _createElementVNode("div", _hoisted_118, [_createElementVNode("button", {
        type: "button",
        "class": "btn btn-primary",
        onClick: copySummary
      }, _cache[82] || (_cache[82] = [_createElementVNode("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.2"
      }, [_createElementVNode("rect", {
        x: "9",
        y: "9",
        width: "13",
        height: "13",
        rx: "2"
      }), _createElementVNode("path", {
        d: "M5 15V5a2 2 0 0 1 2-2h10"
      })], -1), _createTextVNode(" Copy summary ")])), _unref(copied) ? (_openBlock(), _createElementBlock("span", _hoisted_119, " Copied ")) : _createCommentVNode("", true)])])])]), _cache[90] || (_cache[90] = _createStaticVNode("<div class=\"trust trust-bottom\" data-v-7dfbd0ca><span class=\"chip\" data-v-7dfbd0ca><span class=\"dot\" data-v-7dfbd0ca></span> Fees verified June 2026 </span><span class=\"chip\" data-v-7dfbd0ca><span class=\"dot\" data-v-7dfbd0ca></span> No sign-up, data stays in your browser </span></div>", 1)), _unref(showEmbedCard) ? (_openBlock(), _createElementBlock("section", _hoisted_120, [_cache[85] || (_cache[85] = _createElementVNode("div", {
        "class": "card-h"
      }, [_createElementVNode("h2", {
        id: "embed-h"
      }, " Add calculator to your site ")], -1)), _cache[86] || (_cache[86] = _createElementVNode("p", {
        "class": "card-sub"
      }, " Copy the snippet and paste it into any page or blog post. It resizes to fit and works on mobile. ", -1)), _createElementVNode("textarea", {
        "class": "embed-input",
        readonly: "",
        rows: "4",
        spellcheck: "false",
        value: embedSnippet.value,
        "aria-label": "Embed code",
        onClick: _cache[20] || (_cache[20] = function ($event) {
          return $event.target.select();
        })
      }, null, 8, _hoisted_121), _createElementVNode("div", _hoisted_122, [_createElementVNode("button", {
        type: "button",
        "class": "btn btn-primary",
        onClick: copyEmbed
      }, _cache[84] || (_cache[84] = [_createElementVNode("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.2"
      }, [_createElementVNode("rect", {
        x: "9",
        y: "9",
        width: "13",
        height: "13",
        rx: "2"
      }), _createElementVNode("path", {
        d: "M5 15V5a2 2 0 0 1 2-2h10"
      })], -1), _createTextVNode(" Copy embed code ")])), _createElementVNode("button", {
        type: "button",
        "class": "btn btn-ghost",
        onClick: _cache[21] || (_cache[21] = function ($event) {
          return showPreview.value = !_unref(showPreview);
        })
      }, _toDisplayString(_unref(showPreview) ? 'Hide preview' : 'Preview embed'), 1), _unref(embedCopied) ? (_openBlock(), _createElementBlock("span", _hoisted_123, " Copied ")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _unref(isEmbed) ? (_openBlock(), _createElementBlock("p", _hoisted_124, _cache[87] || (_cache[87] = [_createTextVNode(" Powered by "), _createElementVNode("a", {
        href: "https://www.salehoo.com",
        target: "_blank",
        rel: "noopener"
      }, "SaleHoo", -1)]))) : _createCommentVNode("", true), _unref(showPreview) ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        "class": "modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "epc-preview-title",
        onClick: _cache[23] || (_cache[23] = _withModifiers(function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        }, ["self"]))
      }, [_createElementVNode("div", _hoisted_125, [_createElementVNode("div", _hoisted_126, [_cache[89] || (_cache[89] = _createElementVNode("h3", {
        id: "epc-preview-title"
      }, " Embed preview ", -1)), _createElementVNode("button", {
        type: "button",
        "class": "x",
        "aria-label": "Close preview",
        onClick: _cache[22] || (_cache[22] = function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        })
      }, _cache[88] || (_cache[88] = [_createElementVNode("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.4"
      }, [_createElementVNode("path", {
        d: "M6 6l12 12M18 6L6 18"
      })], -1)]))]), _createElementVNode("div", _hoisted_127, [_createElementVNode("div", _hoisted_128, [_createElementVNode("iframe", {
        ref_key: "previewFrameRef",
        ref: previewFrameRef,
        "class": "preview-frame",
        src: _unref(previewSrc),
        title: "Embed preview",
        loading: "lazy"
      }, null, 8, _hoisted_129)])])])])) : _createCommentVNode("", true)])], 2);
    };
  }
};